import fetchMainMenu from './mainmenu'
import fetchServices from './services'
import fetchSubMenu from './submenu'
import fetchInformation from "./information";

const navigation = {
    information: fetchInformation,
    main: fetchMainMenu,
    services: fetchServices,
    submenu: fetchSubMenu,
}
export default navigation